<template lang="pug">
.main-content
    #container.wrap-content.container
        payment-warning 
        // start: CONTENT-TITLE
        section#page-title
            .row
                .col-sm-8
                    h1.mainTitle  {{ mainTitle }}
                    span.mainDescription
                        template(v-if="mainDescription") {{ mainDescription }}
                        template(v-else) 
                            slot(name="description")
                .col-sm-4
                    slot(name="right")
            ol.breadcrumb
                li(
                    v-for="item in links", 
                    :class="{active: typeof item === 'string'}"
                )
                    template(v-if="typeof item === 'string'") {{ item }}
                    template(v-else) 
                        router-link(:to="{name: item.component}") {{ item.title }}
        // end: CONTENT-TITLE
        // start: CONTENT
        .container-fluid.container-fullw.bg-white
            slot
        .container-fluid.container-fullw(v-if="$slots.second")
            slot(name="second")
</template>

<script>
import PaymentWarning from '@/components/payments/PaymentWarning';

export default {
    name: 'Page',
    components: {
        PaymentWarning
    },
    mounted: function() {
        // TODO убрать эту херню. Она фиксит отсутствие скролла на вкладках, на которые переходишь после загрузки страницы
        setInterval(function() { window.dispatchEvent(new Event('resize')); }, 500);
    },
    props: {
        mainTitle: String,
        mainDescription: String,
        links: {
            type: Array,
            default: () => []
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/core/Page.vue